import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { Endpoint } from './endpoint';
import { ErrorHandler } from './error-handler';

@Injectable({
  providedIn: 'root'
})
export class Api {
  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandler,
    private endpoints: Endpoint
  ) {}

  get<T>(url: string, params?: any) {
    return this.http
      .get<T>(this.endpoints.apiBase + url, { params })
      .pipe(catchError(err => this.errorHandler.handle(err)));
  }

  post<T>(url: string, body: any) {
    return this.http
      .post<T>(this.endpoints.apiBase + url, body)
      .pipe(catchError(err => this.errorHandler.handle(err)));
  }

  put<T>(url: string, body: any) {
    return this.http
      .put<T>(this.endpoints.apiBase + url, body)
      .pipe(catchError(err => this.errorHandler.handle(err)));
  }

  delete<T>(url: string) {
    return this.http
      .delete<T>(this.endpoints.apiBase + url)
      .pipe(catchError(err => this.errorHandler.handle(err)));
  }
}
